<div
  class="pagina"
  [class.pagina--kaufmann]="marca === 'kaufmann'"
  [class.pagina--andes-motor]="marca === 'andes-motor'"
>
  @if (marca === 'kaufmann') {
    <header class="nav nav--kaufmann">
      <img class="nav__logo nav__logo--kaufmann" src="logos/kaufmann.svg" alt="Kaufmann" />
    </header>
  } @else {
    <header class="nav nav--andes-motor">
      <img class="nav__logo nav__logo--andes-motor" src="logos/andesmotor.svg" alt="Andes Motor" />
    </header>
  }

  <app-widget-consentimiento
    [modal]="false"
    [abierto]="true"
    [tema]="marca"
    [codSociedad]="config.codSociedad"
    [origen]="config.origen"
    [colorTexto]="config.colorTexto"
    [colorFondo]="config.colorFondo"
    [colorBoton]="config.colorBoton"
    [colorTextoBoton]="config.colorTextoBoton"
    [rut]="config.datosCliente?.rut ?? null"
    [nombres]="config.datosCliente?.nombres ?? null"
    [apellidos]="config.datosCliente?.apellidos ?? null"
    [email]="config.datosCliente?.email ?? null"
    [telefono]="config.datosCliente?.telefono ?? null"
  ></app-widget-consentimiento>
</div>
